import { ReactElement, ReactNode } from 'react'

import { IconName } from '../../../Icon'
import { NavItem } from '../../../NavList'

export interface DrawerStepProps {
  actions?: NavItem[]
  children?: ReactNode
  customContent?: ReactNode
  icon?: IconName
  onAction?: (id: string, value: string) => void
  title?: ReactNode
}

export const DrawerStep = ({ children }: DrawerStepProps): ReactElement => <>{children}</>
